



import ShowListComponent from "@/components/admin/show/showListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ShowListPage",
  components: {
    ShowListComponent,
  },
})
export default class ShowListPage extends Vue {}
